/**
 * Hero Banner - Mobile Optimized
 */

document.addEventListener('DOMContentLoaded', function() {
  const heroSection = document.querySelector('.hero-section');
  if (!heroSection) return;
  
  const slideshow = heroSection.querySelector('.hero-slideshow');
  const slides = heroSection.querySelectorAll('.hero-slide');
  const indicators = heroSection.querySelectorAll('.hero-indicator');
  const prevButton = heroSection.querySelector('.hero-arrow-prev');
  const nextButton = heroSection.querySelector('.hero-arrow-next');
  
  if (slides.length === 0) return;
  
  let currentSlide = 0;
  let autoplayInterval;
  let isTransitioning = false;
  let touchStartX = 0;
  let touchEndX = 0;
  const autoplaySpeed = 5000;
  
  // ================================================
  // SLIDE NAVIGATION
  // ================================================
  
  function goToSlide(index) {
    if (isTransitioning) return;
    
    isTransitioning = true;
    
    // Update slides
    slides[currentSlide].classList.remove('active');
    if (indicators[currentSlide]) {
      indicators[currentSlide].classList.remove('active');
    }
    
    currentSlide = index;
    slides[currentSlide].classList.add('active');
    if (indicators[currentSlide]) {
      indicators[currentSlide].classList.add('active');
    }
    
    // Allow next transition after animation
    setTimeout(() => {
      isTransitioning = false;
    }, 500);
    
    // Reset autoplay
    if (slides.length > 1) {
      resetAutoplay();
    }
  }
  
  function nextSlide() {
    const next = (currentSlide + 1) % slides.length;
    goToSlide(next);
  }
  
  function prevSlide() {
    const prev = (currentSlide - 1 + slides.length) % slides.length;
    goToSlide(prev);
  }
  
  // ================================================
  // AUTOPLAY
  // ================================================
  
  function startAutoplay() {
    if (slides.length <= 1) return;
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }
  
  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }
  
  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }
  
  // ================================================
  // TOUCH GESTURES - OPTIMIZED
  // ================================================
  
  let touchStartTime = 0;
  
  slideshow.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    touchStartTime = Date.now();
    stopAutoplay(); // Stop autoplay when touching
  }, { passive: true });
  
  slideshow.addEventListener('touchmove', (e) => {
    // Prevent vertical scroll while swiping if needed
    const touchCurrentX = e.changedTouches[0].screenX;
    const diff = Math.abs(touchStartX - touchCurrentX);
    
    if (diff > 10) {
      // User is swiping horizontally
      e.preventDefault();
    }
  }, { passive: false });
  
  slideshow.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const touchDuration = Date.now() - touchStartTime;
    handleSwipe(touchDuration);
    
    // Resume autoplay after touch
    if (slides.length > 1) {
      startAutoplay();
    }
  }, { passive: true });
  
  function handleSwipe(duration) {
    const swipeThreshold = 50;
    const maxSwipeTime = 500; // Quick swipes only
    const diff = touchStartX - touchEndX;
    
    if (Math.abs(diff) > swipeThreshold && duration < maxSwipeTime) {
      if (diff > 0) {
        // Swipe left - next slide
        nextSlide();
      } else {
        // Swipe right - previous slide
        prevSlide();
      }
    }
  }
  
  // ================================================
  // BUTTON CONTROLS
  // ================================================
  
  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      nextSlide();
    });
  }
  
  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      prevSlide();
    });
  }
  
  // ================================================
  // INDICATOR DOTS
  // ================================================
  
  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', (e) => {
      e.preventDefault();
      goToSlide(index);
    });
  });
  
  // ================================================
  // KEYBOARD NAVIGATION (Desktop)
  // ================================================
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    }
  });
  
  // ================================================
  // VISIBILITY CHANGE (Pause when tab hidden)
  // ================================================
  
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });
  
  // ================================================
  // INITIALIZE
  // ================================================
  
  if (slides.length > 1) {
    startAutoplay();
  }
  
  // Accessibility
  slideshow.setAttribute('role', 'region');
  slideshow.setAttribute('aria-label', 'Hero slideshow');
  
});